import React from 'react';

const ImageModal = ({ src, alt, onClose }) => {
  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="relative max-w-5xl w-full px-4"
        onClick={(e) => e.stopPropagation()}
        role="presentation"
      >
        <button
          onClick={onClose}
          className="absolute -top-6 right-0 bg-orange-500 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg hover:bg-orange-600 transition"
          aria-label="Fermer"
        >
          ×
        </button>
        <div className="overflow-auto rounded-2xl border border-orange-400/40 shadow-xl max-h-[80vh]">
          <img src={src} alt={alt} className="w-full h-auto" />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
